import BaseMapper from '../../BaseMapper';

const EventAddMapper = (data, context) => {
    return data;
};

export default EventAddMapper;
